import en from './en';
import fr from './fr';

const messages = { en, fr };

export default messages;
